import { Gauge } from 'lucide-react';
import { DEFAULT_FUEL_AMOUNT, MESSAGE } from '@/shared/consts';

type TSavingsCalculationGuideItemProps = {
	efficiency?: number | null;
	averageFuelAmount?: number | null;
};

const SavingsCalculationGuideItem = ({
	efficiency,
	averageFuelAmount,
}: TSavingsCalculationGuideItemProps) => {
	const fuelAmount = averageFuelAmount ?? DEFAULT_FUEL_AMOUNT;
	const calculationBasisText = efficiency
		? MESSAGE.RECOMMENDATION.SAVINGS_CALCULATION_BASIS_WITH_FUEL_EFFICIENCY(
				efficiency,
				fuelAmount,
			)
		: MESSAGE.RECOMMENDATION.SAVINGS_CALCULATION_BASIS_WITHOUT_FUEL_EFFICIENCY(
				fuelAmount,
			);

	return (
		<li className="list-none border-mantang-gray-100 border-b px-5 py-3">
			<div className="flex items-center gap-3 rounded-lg border border-mantang-primary bg-mantang-gray-50 px-3 py-3">
				<div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-mantang-bg-yellow text-mantang-primary">
					<Gauge size={17} strokeWidth={2.4} />
				</div>
				<div className="flex min-w-0 flex-col gap-1">
					<p className="font-medium text-mantang-gray-900 text-xs">
						예상 절약액 계산 기준
					</p>
					<p className="truncate text-[11px] text-mantang-gray-500">
						{calculationBasisText}
					</p>
				</div>
			</div>
		</li>
	);
};

export default SavingsCalculationGuideItem;
